/*
 * @Author: 吴文洁
 * @Date: 2019-08-26 16:38:31
 * @LastEditors: renmanyi
 * @LastEditTime: 2021-06-24 18:00:20
 * @Description:
 */
/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from '@/router/router'
import store from '@/store';
import { install as XMPluginInstall } from '@/plugins';
import { isMobile } from '@/common/utils/getPlaform';
import WheatUI from 'wheat-ui';
import VueQuillEditor from 'vue-quill-editor';

import TransferDom from '@/common/directives/transfer-dom';
import formatDate from '@/common/filters/formatDate';
import dealWithName from '@/common/filters/dealWithName';
import dealRoutePath from '@/common/filters/dealRoutePath';

import '@/common/styles/initial.less'
import 'wheat-ui/lib/wheat-ui.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

Vue.use(XMPluginInstall);
Vue.use(WheatUI);
const handleCustomMatcher = (node:any, Delta:any) => {
  let ops:Array<any> = [];
  Delta.ops.forEach((op:any) => {
    if (op.insert && typeof op.insert === 'string') {// 如果粘贴了图片，这里会是一个对象，所以可以这样处理
      ops.push({
        insert: op.insert,
      });
    }
  })
  Delta.ops = ops;
  return Delta;
}
/**
 * hotfix: 【前端-前端一-营销】5.0小麦秀编辑文本格式，再进入编辑页展示为默认格式
 * jira: http://jira.ixm5.cn/browse/XSGZ-1407
*/
const editorOptions = {
  placeholder: '',
  modules: {
    clipboard: {
       // 粘贴版，处理粘贴禁止带图片
       matchers: [['img', handleCustomMatcher]],
    },
    toolbar: isMobile() ? [] : [
      ['bold', 'italic', 'underline'],
      [{ 'color': [] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ]
  }
}
Vue.use(VueQuillEditor, editorOptions);



const filters = {
  formatDate,
  dealWithName,
  dealRoutePath,
}
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as any)[key]);
});

Vue.directive('transfer-dom', TransferDom);
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
// 使用修饰器模式添加before以及after函数
const FunProp: any = Function.prototype;

FunProp.before = function (beforeFn: Function): Function {
  var _self = this;

  return function (this: any) {
    beforeFn.apply(this, arguments);
    return _self.apply(this, arguments);
  }
}

FunProp.after = function (afterFn: Function) {
  const _self: Function = this;
  return function (this: any) {
    const ret = _self.apply(this, arguments);
    afterFn.apply(this, arguments);
    return ret;
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
